<template>
  <b-card>
    <template #header>
      <div class="d-flex">
        <h4 class="mb-0">Benefícios</h4>
        <div class="ml-auto">
          <b-button
            v-b-toggle="'collapse-beneficios'"
            size="sm"
            class="mr-1 border-0"
            variant="outline-secondary"
          >
            <span class="when-open"><font-awesome-icon icon="eye" /></span>
            <span class="when-closed"
              ><font-awesome-icon icon="eye-slash"
            /></span>
          </b-button>
        </div>
      </div>
    </template>

    <b-collapse id="collapse-beneficios" visible>
      <div class="d-flex mb-2">
        <div class="w-50">
          <b-input-group size="sm">
            <b-form-input
              v-model="search"
              placeholder="Pesquisar"
              @keypress.enter="loadData"
            ></b-form-input>
          </b-input-group>
        </div>
        <div class="ml-auto">
          <b-button size="sm" variant="exitos" @click="addBeneficio()">
            <font-awesome-icon icon="plus" />
            Adicionar Benefício
          </b-button>
        </div>
      </div>

      <b-table
        responsive
        striped
        hover
        show-empty
        :items="beneficios"
        :fields="fields"
      >
        <template #cell(descricao)="{ item }">
          <div class="table-truncate-content">
            {{ item.descricao }}
          </div>
        </template>
        <template #cell(repasse)="{ item }">
          {{ item.repasse | number_format }}
        </template>
        <template #cell(actions)="row">
          <Actions
            :item="row.item"
            :view_show="false"
            :edit_to="null"
            @edit="addBeneficio(row.item)"
            @delete="deleteBeneficio(row.item)"
          />
        </template>
        <template #empty="{}">
          <h5 class="text-center">Nenhum item cadastrado</h5>
        </template>
      </b-table>
      <div>
        <pagination-nav :pagination="pagination" @input="loadData()" />
      </div>
    </b-collapse>

    <Estatisticas :valores="oportunidade_estatisticas.beneficios" />

    <b-modal
      title="Dados da Beneficio"
      id="modal-beneficio"
      ref="modal-beneficio"
      size="lg"
      ok-variant="exitos"
      @ok="saveBeneficio"
      @hidden="resetEdit"
    >
      <form-beneficios :value="beneficio_edit" ref="form-beneficio" />
    </b-modal>
  </b-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Actions from "@/components/Table/Actions.vue";
import FormBeneficios from "./FormBeneficios.vue";
import Estatisticas from "./Estatisticas.vue";
export default {
  components: { Actions, FormBeneficios, Estatisticas },
  data: () => ({
    beneficios: [],
    beneficio_index: null,
    beneficio_edit: null,
    pagination: {
      currentPage: 1,
      perPage: 10,
      total: 0,
    },
    search: "",
  }),
  computed: {
    ...mapState("oportunidades", ["oportunidade", "oportunidade_estatisticas"]),
    fields() {
      return [
        {
          key: "beneficio",
          label: "Beneficio",
          class: "col-4",
          sortable: true,
        },
        { key: "descricao", label: "Descrição", class: "table-truncate" },
        { key: "repasse", label: "Repasse", class: "col-2", sortable: true },
        { key: "actions", label: "", class: "cell-actions" },
      ];
    },
  },
  methods: {
    ...mapActions("oportunidades", [
      "ActionGetAllBeneficios",
      "ActionSaveBeneficio",
      "ActionDeleteBeneficio",
    ]),

    addBeneficio(item = null) {
      if (item !== null) {
        this.beneficio_edit = item;
      } else {
        this.beneficio_edit = null;
      }
      this.$bvModal.show("modal-beneficio");
    },
    async deleteBeneficio(beneficio) {
      try {
        await this.ActionDeleteBeneficio(beneficio.id);
        this.$notifications.addNotification({
          message: "Benefício excluído com sucesso",
          type: "success",
        });
        await this.loadData();
      } catch (err) {
        this.$notifications.addNotification({
          message: "Erro ao excluir benefício",
          type: "danger",
        });
      }
    },
    async saveBeneficio(evt) {
      evt.preventDefault();
      let beneficio = await this.$refs["form-beneficio"].save();
      beneficio.oportunidade_id = this.oportunidade.id;

      try {
        await this.ActionSaveBeneficio(beneficio);
        this.$notifications.addNotification({
          message: "Dados salvos com sucesso",
          type: "success",
        });
        await this.loadData();
      } catch (err) {
        this.$notifications.addNotification({
          message: "Erro ao salvar benefício",
          type: "danger",
        });
      }

      this.$nextTick(() => {
        this.$bvModal.hide("modal-beneficio");
      });
    },
    async loadData(evt) {
      if (evt) {
        evt.preventDefault();
      }
      let response = await this.ActionGetAllBeneficios({
        page: this.pagination.current_page,
        per_page: this.pagination.per_page,
        orderBy: this.sortBy,
        sortBy: this.sortDesc ? "desc" : "asc",
        q: this.search,
        oportunidade_id: this.oportunidade.id,
      });
      this.beneficios = response.data;
      this.pagination = response.meta;
    },
    resetEdit() {
      this.beneficio_index = null;
      this.beneficio_edit = null;
    },
  },
  created() {
    this.loadData();
  },
};
</script>

<style lang="scss" >
.list-beneficios {
  .handle {
    cursor: grab;

    &:active {
      cursor: grabbing;
    }
  }

  .td-item {
    padding-top: 0.3rem;
    padding-bottom: 0;
  }
}

.table-truncate {
  max-width: 0;

  .table-truncate-content {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
